export default "__VITE_PUBLIC_ASSET__80005324__"